export function imgload(element: HTMLElement, handler?: (value: void[]) => void ): Promise<void[]> {

  let singleImagePromise = (img: HTMLImageElement): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
      if (img.src && img.complete) {
        resolve();
      }
      else {
        img.addEventListener('load', () => {
          resolve();
        });
        img.addEventListener('error', () => {
          reject();
        });
      }
    });
  };

  let promises: Promise<void>[] = [];
  if (element instanceof HTMLImageElement) {
    promises.push(singleImagePromise(element));
  } else {
    let list = element.querySelectorAll('img');
    for (let i=0; i<list.length; i++) {
      promises.push(singleImagePromise(list[i]));
    }
  }

  // Not async
  if (handler instanceof Function) {
    Promise.all(promises).then(handler);
  }
  // Async
  else {
    promises;
    return Promise.all(promises);
  }
}


export function imgloaded(element: HTMLElement): boolean {
  if (element instanceof HTMLImageElement) {
    return (element.src && element.complete);
  } else {
    let list = element.querySelectorAll('img');
    for (let i=0; i<list.length; i++) {
      let img = list[0];
      if (!(img.src && img.complete)) {
        return false;
      }
    }
    return true;
  }
}